const actions = {

  updateShakePopupClose ({ commit }, shakePopupClose) {
    commit({
      type: 'updateShakePopupClose',
      shakePopupClose
    })
  }

}

export default actions;



// WEBPACK FOOTER //
// ./src/starcharge/store/actions.js